// import React , { useEffect, useState } from 'react'
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
// import format from 'date-fns/format'
// import parse from 'date-fns/parse'
// import startOfWeek from 'date-fns/startOfWeek'
// import getDay from 'date-fns/getDay'
// import enUS from 'date-fns/locale/en-US'
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Popping from './Popping';
// import {closeEvent, ShowEventApi, ShowEventsApi} from "../Redux/actions"
// import { connect } from 'react-redux'

// const locales = {
//   'en-US': enUS,
// }

// const localizer = dateFnsLocalizer({
//   format,
//   parse,
//   startOfWeek,
//   getDay,
//   locales,
// })





// const MyCalendar = ({events, ShowEventApi, closeEvent, ShowEventsApi}) => {
//     const [open, setOpen] = useState(false);
//     const [renderStatus, rerender] = useState(false);

//     useEffect(()=>{
//       ShowEventsApi()
//       console.log("i renderd because of refresh or start");
//     },[])


//     useEffect(()=>{
//       ShowEventsApi()
//       console.log("i renderd");
//     },[renderStatus])
   

//     const openEventClick = (event)=>{
//          setOpen(true)
//          if(event.id) {
//           ShowEventApi( event.id);
//          }
         
//          return;
//     }

//     const closeEventClick = () =>{
//       setOpen(false);
//       setTimeout(()=>closeEvent(),300) ;
//     }
    
//     return (
//     <div>
//         <Popping open={open}
//          handleOpen={openEventClick} 
//          handleClose={closeEventClick} 
//          renderStatus = {renderStatus} 
//          rerender= {rerender}/>
//         <Calendar
//             localizer={localizer}
//             events={events}
//             startAccessor="start"
//             endAccessor="end"
//             style={{ height: 500 , margin: 50, fontFamily: '#273238',fontWeight:'bold',
            
//            }}
//             onSelectEvent={openEventClick}
//         />
//     </div>
        
//     )
// }

// function mapStateToProps({event, events}){
//   return{
//     event,
//     events
//   }
// }

// export default connect(mapStateToProps, {ShowEventApi, closeEvent, ShowEventsApi})(MyCalendar)

//2ND CODE
// src/components/Calendar.jsx
// import React, { useEffect, useState } from 'react';
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
// import format from 'date-fns/format';
// import parse from 'date-fns/parse';
// import startOfWeek from 'date-fns/startOfWeek';
// import getDay from 'date-fns/getDay';
// import enUS from 'date-fns/locale/en-US';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Popping from './Popping';
// import { closeEvent, ShowEventApi, ShowEventsApi } from '../Redux/actions';
// import { connect } from 'react-redux';

// const locales = {
//   'en-US': enUS,
// };

// const localizer = dateFnsLocalizer({
//   format,
//   parse,
//   startOfWeek,
//   getDay,
//   locales,
// });

// const EventComponent = ({ event }) => {
//   return (
//     <div>
//       <strong>{event.title}</strong>
//       <p>{event.start.toLocaleString()} - {event.end.toLocaleString()}</p>
//     </div>
//   );
// };

// const ToolbarComponent = ({ label, onNavigate, onView }) => {
//   return (
//     <div>
//       <button className='red' onClick={() => onNavigate('TODAY')}>Today</button>
//       <button className='red1' onClick={() => onNavigate('PREV')}>Back</button>
//       <button className='red2' onClick={() => onNavigate('NEXT')}>Next</button>
//       <span>{label}</span>
//       <button className='blue' onClick={() => onView('month')}>Month</button>
//       <button className='blue1' onClick={() => onView('week')}>Week</button>
//       <button className='blue2' onClick={() => onView('day')}>Day</button>
//       <button className='blue3' onClick={() => onView('agenda')}>Event list</button>


//     </div>
//   );
// };

// const MyCalendar = ({ events, ShowEventApi, closeEvent, ShowEventsApi }) => {
//   const [open, setOpen] = useState(false);

  
//   useEffect(() => {
//     const fetchData = async () => {
//       await ShowEventsApi();
//     };

//     fetchData();
//   }, [ShowEventsApi]); // Fetch events on mount

//   const openEventClick = (event) => {
//     setOpen(true);
//     if (event.id) {
//       ShowEventApi(event.id);
//     }
//   };

//   const closeEventClick = () => {
//     setOpen(false);
//     setTimeout(() => closeEvent(), 300);
//   };

//   return (
//     <div>
//       <Popping
//         open={open}
//         handleOpen={openEventClick}
//         handleClose={closeEventClick}
//       />
//       <Calendar
//         localizer={localizer}
//         events={events}
//         startAccessor="start"
//         endAccessor="end"
//         style={{
//           height: 500,
//           margin: 50,
//           fontFamily: '#273238',
//           fontWeight: 'bold',
//         }}
//         components={{
//           event: EventComponent,
//           toolbar: ToolbarComponent,
//         }}
//         onSelectEvent={openEventClick}
//       />
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     events: state.events, // Adjust this according to your actual state structure
//   };
// };

// export default connect(mapStateToProps, { ShowEventApi, closeEvent, ShowEventsApi })(MyCalendar);

//-3rd------------------------------------

// MyCalendar.jsx

// import React, { useEffect, useState } from 'react';
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
// import format from 'date-fns/format';
// import parse from 'date-fns/parse';
// import startOfWeek from 'date-fns/startOfWeek';
// import getDay from 'date-fns/getDay';
// import enUS from 'date-fns/locale/en-US';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Popping from './Popping';
// import { closeEvent, ShowEventApi, ShowEventsApi } from '../Redux/actions';
// import { connect } from 'react-redux';

// const locales = {
//   'en-US': enUS,
// };

// const localizer = dateFnsLocalizer({
//   format,
//   parse,
//   startOfWeek,
//   getDay,
//   locales,
// });

// const ToolbarComponent = ({ label, onNavigate, onView }) => {
//   return (
//     <div>
//       <button className='red' onClick={() => onNavigate('TODAY')}>Today</button>
//       <button className='red1' onClick={() => onNavigate('PREV')}>Back</button>
//       <button className='red2' onClick={() => onNavigate('NEXT')}>Next</button>
//       <span>{label}</span>
//       <button className='blue' onClick={() => onView('month')}>Month</button>
//       <button className='blue1' onClick={() => onView('week')}>Week</button>
//       <button className='blue2' onClick={() => onView('day')}>Day</button>
//     </div>
//   );
// };

// const MyCalendar = ({ events, ShowEventApi, closeEvent, ShowEventsApi }) => {
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       await ShowEventsApi();
//     };

//     fetchData();
//   }, [ShowEventsApi]);

//   const openEventClick = (event) => {
//     setOpen(true);
//     if (event.id) {
//       ShowEventApi(event.id);
//     }
//   };

//   const closeEventClick = () => {
//     setOpen(false);
//     setTimeout(() => closeEvent(), 300);
//   };

//   const downloadEventList = () => {
//     const eventData = events.map(event => ({
//       title: event.title,
//       start: event.start,
//       end: event.end,
//     }));

//     const csvData = eventData.map(event => `${event.title},${event.start},${event.end}`).join('\n');

//     const blob = new Blob([csvData], { type: 'text/csv' });

//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(blob);
//     a.download = 'event_list.csv';
//     a.click();
//   };

//   return (
//     <div>
//       <Popping
//         open={open}
//         handleOpen={openEventClick}
//         handleClose={closeEventClick}
//       />
//       <Calendar
//         localizer={localizer}
//         events={events}
//         startAccessor="start"
//         endAccessor="end"
//         style={{
//           height: 500,
//           margin: 50,
//           fontFamily: '#273238',
//           fontWeight: 'bold',
//         }}
//         components={{
//           toolbar: (props) => (
//             <ToolbarComponent {...props} />
//           ),
//         }}
//         onSelectEvent={openEventClick}
//       />
//       <div style={{ marginTop: '15px', marginLeft:'50px'}}>
//         <button className='blue3' onClick={downloadEventList}>Download Event List</button>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     events: state.events,
//   };
// }yy

// export default connect(mapStateToProps, { ShowEventApi, closeEvent, ShowEventsApi })(MyCalendar);


//--- 3rd

// MyCalendar.jsx

// import React, { useEffect, useState } from 'react';
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
// import format from 'date-fns/format';
// import parse from 'date-fns/parse';
// import startOfWeek from 'date-fns/startOfWeek';
// import getDay from 'date-fns/getDay';
// import enUS from 'date-fns/locale/en-US';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Popping from './Popping';
// import { closeEvent, ShowEventApi, ShowEventsApi } from '../Redux/actions';
// import { connect } from 'react-redux';

// const locales = {
//   'en-US': enUS,
// };

// const localizer = dateFnsLocalizer({
//   format,
//   parse,
//   startOfWeek,
//   getDay,
//   locales,
// });

// const ToolbarComponent = ({ label, onNavigate, onView }) => {
//   return (
//     <div>
//       <button className='red' onClick={() => onNavigate('TODAY')}>Today</button>
//       <button className='red1' onClick={() => onNavigate('PREV')}>Back</button>
//       <button className='red2' onClick={() => onNavigate('NEXT')}>Next</button>
//       <span>{label}</span>
//       <button className='blue' onClick={() => onView('month')}>Month</button>
//       <button className='blue1' onClick={() => onView('week')}>Week</button>
//       <button className='blue2' onClick={() => onView('day')}>Day</button>
//       <button className='blue3' onClick={() => onView('agenda')}>Event list</button>
//     </div>
//   );
// };

// const MyCalendar = ({ events, ShowEventApi, closeEvent, ShowEventsApi }) => {
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       await ShowEventsApi();
//     };

//     fetchData();
//   }, [ShowEventsApi]);

//   const openEventClick = (event) => {
//     setOpen(true);
//     if (event.id) {
//       ShowEventApi(event.id);
//     }
//   };

//   const closeEventClick = () => {
//     setOpen(false);
//     setTimeout(() => closeEvent(), 300);
//   };

//   const downloadEventList = () => {
//     // Add heading names for each column
//     const headingNames = ['Event Title', 'Start Time', 'End Time'];

//     const eventData = events.map(event => ({
//       title: event.title,
//       start: event.start,
//       end: event.end,
//     }));

//     // Create CSV data with heading names
//     const csvData =
//       headingNames.join(',') +
//       '\n' +
//       eventData
//         .map(event => `${event.title},${event.start},${event.end}`)
//         .join('\n');

//     const blob = new Blob([csvData], { type: 'text/csv' });

//     const a = document.createElement('a');
//     a.href = URL.createObjectURL(blob);
//     a.download = 'event_list.csv';
//     a.click();
//   };

//   return (
//     <div>
//       <Popping
//         open={open}
//         handleOpen={openEventClick}
//         handleClose={closeEventClick}
//       />
//       <Calendar
//         localizer={localizer}
//         events={events}
//         startAccessor="start"
//         endAccessor="end"
//         style={{
//           height: 500,
//           margin: 50,
//           fontFamily: '#273238',
//           fontWeight: 'bold',
//         }}
//         components={{
//           toolbar: (props) => (
//             <ToolbarComponent {...props} />
//           ),
//         }}
//         onSelectEvent={openEventClick}
//       />
//       <div style={{ marginTop: '10px', marginLeft: '50px' }}>
//         <button className='blue3' onClick={downloadEventList}>Download Event List</button>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     events: state.events,
//   };
// };

// export default connect(mapStateToProps, { ShowEventApi, closeEvent, ShowEventsApi })(MyCalendar);


//4th component

import React, { useEffect, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import enUS from 'date-fns/locale/en-US';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Popping from './Popping';
import { closeEvent, ShowEventApi, ShowEventsApi } from '../Redux/actions';
import { connect } from 'react-redux';

const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const ToolbarComponent = ({ label, onNavigate, onView }) => {
  return (
    <div>
      <button className='red' onClick={() => onNavigate('TODAY')}>Today</button>
      <button className='red1' onClick={() => onNavigate('PREV')}>Back</button>
      <button className='red2' onClick={() => onNavigate('NEXT')}>Next</button>
      <span>{label}</span>
      <button className='blue' onClick={() => onView('month')}>Month</button>
      <button className='blue1' onClick={() => onView('week')}>Week</button>
      <button className='blue2' onClick={() => onView('day')}>Day</button>
      <button className='blue3' onClick={() => onView('agenda')}>Event list</button>
    </div>
  );
};

const MyCalendar = ({ events, ShowEventApi, closeEvent, ShowEventsApi }) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      await ShowEventsApi();
    };

    fetchData();
  }, [ShowEventsApi]);

  const openEventClick = (event) => {
    setOpen(true);
    if (event.id) {
      ShowEventApi(event.id);
    }
  };

  const closeEventClick = () => {
    setOpen(false);
    setTimeout(() => closeEvent(), 300);
  };

  const downloadEventList = () => {
    // Add heading names for each column
    const headingNames = ['Event Title', 'Start Time', 'End Time'];

    const eventData = events.map(event => ({
      title: event.title,
      start: event.start,
      end: event.end,
    }));

    // Create CSV data with heading names
    const csvData =
      headingNames.join(',') +
      '\n' +
      eventData
        .map(event => `${event.title},${event.start},${event.end}`)
        .join('\n');

    const blob = new Blob([csvData], { type: 'text/csv' });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'event_list.csv';
    a.click();
  };

  return (
    <div>
      <Popping
        open={open}
        handleOpen={openEventClick}
        handleClose={closeEventClick}
      />

      {/* Search Input */}
      <div style={{ marginLeft: '5px' ,
         marginTop:'4px'}}>
        <input
             style={{ marginLeft: '520px',
             marginTop:'7px' , paddingRight:'100px',paddingLeft:'5px'}}

          type="text"
          placeholder="Search event"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button className='search' onClick={() => setSearchTerm('')}>Clear</button>
      </div>

      {/* Calendar */}
      <Calendar
        localizer={localizer}
        events={events.filter((event) =>
          event.title.toLowerCase().includes(searchTerm.toLowerCase())
        )}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: 500,
          margin: 50,
          fontFamily: '#273238',
          fontWeight: 'bold',
        }}
        components={{
          toolbar: (props) => (
            <ToolbarComponent {...props} />
          ),
        }}
        onSelectEvent={openEventClick}
      />

      {/* Download Event List Button */}
      <div style={{ marginTop: '1px', marginLeft: '50px' }}>
        <button className='blue3' onClick={downloadEventList}>Download Event List</button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    events: state.events,
  };
};

export default connect(mapStateToProps, { ShowEventApi, closeEvent, ShowEventsApi })(MyCalendar);



